import { render, staticRenderFns } from "./FutureContractSpecs.vue?vue&type=template&id=4a25d41a&scoped=true&"
import script from "./FutureContractSpecs.vue?vue&type=script&lang=js&"
export * from "./FutureContractSpecs.vue?vue&type=script&lang=js&"
import style0 from "./FutureContractSpecs.vue?vue&type=style&index=0&lang=css&"
import style1 from "./FutureContractSpecs.vue?vue&type=style&index=1&id=4a25d41a&lang=scss&scoped=true&"
import style2 from "./FutureContractSpecs.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../front.sfc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a25d41a",
  null
  
)

export default component.exports